<template>

    <Layout :title="auth.user.name">

        <div to="modal">
            <transition enter-active-class="transition duration-300 ease-out transform"
                enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition duration-100 ease-in" leave-class="opacity-100"
                leave-to-class="opacity-0">
                <modal v-if="flash.success" title="Succes" :message="flash.success"></modal>
            </transition>
        </div>
        <div to="modal">
            <transition enter-active-class="transition duration-300 ease-out transform"
                enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition duration-100 ease-in" leave-class="opacity-100"
                leave-to-class="opacity-0">
                <modal v-if="flash.error" title="Succes" :message="flash.error"></modal>
            </transition>
        </div>



        <div class="flex mt-8 text-lg" id="titleText">
            <div class="flex m-auto text-center">
                <p class="text-gray-600">{{ auth.user.name }}</p>
                <p class="text-gray-400">, making it </p>
                <p class="ml-1 text-gray-600">a bit safer.today</p>
            </div>
        </div>


        <div class="mt-12 flex ml-8">
            <form>
                <label for="name" class="block text-sm font-medium text-warm-gray-900">Naam</label>
                <div class="mt-1">
                    <input type="text" name="name" id="name" required v-model="form.name"
                        class="block w-full rounded-md border-warm-gray-300 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-teal-600 focus:ring-teal-600">
                    <p class="text-sm text-red-600" v-if="errors.name != null" id="errors">{{ $page.props.errors.name }}
                    </p>
                </div>
                <label for="email" class="block text-sm font-medium text-warm-gray-900 mt-2">E-mail</label>
                <div class="mt-1">
                    <input type="text" name="email" id="email" required v-model="form.email"
                        class="block w-full rounded-md border-warm-gray-300 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-teal-600 focus:ring-teal-600">
                    <p class="text-sm text-red-600" v-if="errors.email != null" id="errors">{{
                        $page.props.errors.email
                    }}</p>
                </div>

                <label for="password" class="block text-sm font-medium text-warm-gray-900 mt-4">Wachtwoord</label>
                <div class="mt-1">
                    <input type="password" name="password" id="password" placeholder="Nieuw wachtwoord"
                        v-model="form.password"
                        class="block w-full rounded-md border-warm-gray-300 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-teal-600 focus:ring-teal-600">

                </div>
                <label for="password_confirmation" class="block text-sm font-medium text-warm-gray-900">Bevestig
                    wachtwoord</label>
                <div class="mt-1">
                    <input type="password" name="password_confirmation" id="password_confirmation"
                        placeholder="Bevestig wachtwoord" v-model="form.password_confirmation"
                        class="block w-full rounded-md border-warm-gray-300 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-teal-600 focus:ring-teal-600">
                    <p class="text-sm text-red-600" v-if="errors.password != null" id="errors">{{
                        $page.props.errors.password
                    }}</p>
                </div>

                <div class="mt-4">
                    <button type="button" @click="sendForm()"
                        class="inline-flex items-center rounded-full border border-transparent bg-teal-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:ring-offset-2">Verander
                        wijzigingen</button>
                    <!-- <input type="button" @click="sendForm()" class="" value="Button" name="submitForm"> -->
                </div>
            </form>
        </div>

        <div v-if="is('SuperAdmin')" class="mt-12 flex ml-8" >
            <form>
                <label for="name" class="block text-sm font-medium text-warm-gray-900">Naam</label>
                <div class="mt-1">
                    <input type="text" placeholder="Pieter de Jong" name="name" id="name" required v-model="adminForm.name"
                        class="block w-full rounded-md border-warm-gray-300 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-teal-600 focus:ring-teal-600">
                    <p class="text-sm text-red-600" v-if="errors.name != null" id="errors">{{ $page.props.errors.name }}
                    </p>
                </div>
                <label for="email" class="block text-sm font-medium text-warm-gray-900 mt-2">E-mail</label>
                <div class="mt-1">
                    <input type="text" placeholder="pieterjong@example.com" name="email" id="email" required v-model="adminForm.email"
                        class="block w-full rounded-md border-warm-gray-300 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-teal-600 focus:ring-teal-600">
                    <p class="text-sm text-red-600" v-if="errors.email != null" id="errors">{{
                        $page.props.errors.email
                    }}</p>
                </div>

                <label for="password" class="block text-sm font-medium text-warm-gray-900 mt-4">Wachtwoord</label>
                <div class="mt-1">
                    <input type="password"  name="password" id="password" placeholder="Wachtwoord"
                        v-model="adminForm.password"
                        class="block w-full rounded-md border-warm-gray-300 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-teal-600 focus:ring-teal-600">

                </div>
                <label for="password_confirmation" class="block text-sm font-medium text-warm-gray-900">Bevestig
                    wachtwoord</label>
                <div class="mt-1">
                    <input type="password" name="password_confirmation" id="password_confirmation"
                        placeholder="Bevestig wachtwoord" v-model="adminForm.password_confirmation"
                        class="block w-full rounded-md border-warm-gray-300 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-teal-600 focus:ring-teal-600">
                    <p class="text-sm text-red-600" v-if="errors.password != null" id="errors">{{
                        $page.props.errors.password
                    }}</p>
                </div>

                <div class="mt-4">
                    <button type="button" @click="sendAdminForm()"
                        class="inline-flex items-center rounded-full border border-transparent bg-teal-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:ring-offset-2">Voeg admin toe</button>
                </div>
            </form>
        </div>

    </Layout>

</template>

<script>
import Layout from '../../Shared/Layout.vue';
import Modal from '@/Shared/Modal';

export default {
    components: {
        Layout,
        Modal
    },
    props: {
        auth: Object,
        user: Object,
        flash: Object,
        errors: Object,
    },
    data() {
        return {
            form: {
                name: this.user.data.name,
                email: this.user.data.email,
                password: null,
                password_confirmation: null,
            },
            adminForm: {
                name: null,
                email: null,
                password: null,
                password_confirmation: null,
            }
        };
    },
    methods: {
        onload() {
            console.log(this.auth, this.flash);
        },
        sendForm() {
            if (this.form.name != null && this.form.email != null) {
                this.$inertia.put('/user', this.form);
            }
        },
        sendAdminForm() {
            if (this.adminForm.name != null && this.adminForm.email != null && this.adminForm.password != null && this.adminForm.password_confirmation != null) {
                this.$inertia.post('/user/addadmin', this.adminForm);
                this.adminForm = { name: null, email: null, password: null, password_confirmation: null }
            }
        },

    },
}

</script>